"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var in_view_1 = __importDefault(require("in-view"));
var MultipleItemsPromotion = function () {
    var _a = react_1.default.useState(false), isActive = _a[0], setIsActive = _a[1];
    react_1.default.useEffect(function () {
        (0, in_view_1.default)('.estimateForm-ItemInputCardList_AddItemButton').once('enter', function () {
            setIsActive(true);
        });
    }, []);
    return isActive
        ? (react_1.default.createElement("div", { className: "estimateForm-MultipleItemPromotion" },
            react_1.default.createElement("div", { className: "estimateForm-MultipleItemPromotion_Header" }, "\u5546\u54C1\u8FFD\u52A0\u3067\u91D1\u984D\u30A2\u30C3\u30D7\uFF01"),
            react_1.default.createElement("div", { className: "estimateForm-MultipleItemPromotion_Content" }, "\u9078\u629E\u3057\u3066\u3044\u308B\u5546\u54C1\u30AB\u30C6\u30B4\u30EA\u4EE5\u5916\u3082\u4F9D\u983C\u53EF\u80FD"))) : (null);
};
exports.default = MultipleItemsPromotion;
